import type { NCLink } from '../../../../src/commonTypes';

/**
 * Identify a persisted recipe relationship from the output node's input UIDs.
 * This intentionally supports links saved in either direction so that outputs
 * created before directional recipe links were introduced still render as an
 * input -> output graph.
 */
export const getSynthesiseRecipeFlowEndpoints = (
	link: NCLink
): { from: NCLink['source']; to: NCLink['target'] } | null => {
	const sourceUsesTarget = link.source.synthesiseRecipe?.inputs.some(
		(input) => input.nodeUid === link.target.uid
	);
	if (sourceUsesTarget) return { from: link.target, to: link.source };

	const targetUsesSource = link.target.synthesiseRecipe?.inputs.some(
		(input) => input.nodeUid === link.source.uid
	);
	if (targetUsesSource) return { from: link.source, to: link.target };

	return null;
};

export const isSynthesiseRecipeLink = (link: NCLink): boolean =>
	Boolean(getSynthesiseRecipeFlowEndpoints(link));
